import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService, CourseService } from "@bt/core";

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService,private courseService: CourseService) {}

  public canActivate() {
    if (this.authService.isAuth()) {
      var t=this;
      this.courseService
      .getUser()
      .then(
        (response) => {

          this.router.navigateByUrl("balances");
          
        },
      )
      .catch((error) => {
        console.error(error.error);
        this.authService.logout();
      });
      return false;
    } else {
        return true;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/login.guard.ts